import { Component, inject, Input } from '@angular/core';
import { StatusIconType } from '@sb/ui/status/status-mapping.helper';

import { TimesheetModelEnchanced } from '../../../../../../reducers/orm/timesheet/timesheet.model';
import { TimesheetDayService } from '../../timesheet-day-service';

@Component({
  standalone: false,
  selector: 'timesheet-total-timesheet-edit',
  templateUrl: './timesheet-total-timesheet-edit.component.html',
})
export class TimesheetTotalTimesheetEditComponent {
  private timesheetDayService = inject(TimesheetDayService);

  @Input()
  timesheet: TimesheetModelEnchanced;
  @Input()
  time: number;
  @Input()
  salary: number;
  @Input()
  showSalary: boolean;
  @Input()
  coc: number;
  @Input()
  showCoc = false;

  changeStatus(status: StatusIconType) {
    this.timesheetDayService.status$.next({ timesheet: this.timesheet, status });
  }
}
